import { IconChevronRightSmall } from "@/assets/icons/geist/IconChevronRightSmall";
import { SkeletonBlock } from "@/components/podkit/loading/Skeleton";
import type { FC } from "react";

type BreadcrumbsSkeletonProps = {
    itemsCount: number;
};

export const BreadcrumbsSkeleton: FC<BreadcrumbsSkeletonProps> = ({ itemsCount }) => {
    return (
        <ol className="flex flex-row items-center gap-0.5">
            {Array.from({ length: itemsCount }).map((_, index) => {
                const isLast = index === itemsCount - 1;
                return (
                    <li key={index} className="flex flex-row items-center gap-0.5">
                        <SkeletonBlock ready={false} className="h-5 w-20 rounded-md" />
                        {!isLast && <IconChevronRightSmall size="sm" className="text-content-tertiary" />}
                    </li>
                );
            })}
        </ol>
    );
};
